import { Layout } from "antd";
import styled from "styled-components";

import { FONT_VARIANTS, Text } from "@/components/Typography";
import breakpoints from "@/constants/breakpoints";

const { Header, Content } = Layout;

export const ContentStyled = styled(Content)`
    display: flex;
    flex-direction: column;
    margin: 0;
`;

export const HeaderStyled = styled(Header)`
    height: 40px;
    padding: 0;
    margin-bottom: 24px;
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
`;

export const PageTitle = styled(Text)`
    @media ${breakpoints.xxl} {
       ${FONT_VARIANTS.large};
    }
`;
